import api from '../../services/api-proxy';

const baseRoute = '/api/Eventos';

const EventoApi = {
  // 📥 Listar eventos com filtros e paginação
  async listar(params) {
    try {
      const { data } = await api.get(baseRoute, { params });
      return data;
    } catch (error) {
      console.error('❌ Erro ao listar eventos:', error);
      throw new Error('Erro ao listar eventos.');
    }
  },

  // 🔍 Obter evento por ID
  async buscarPorId(id) {
    try {
      const { data } = await api.get(`${baseRoute}/${id}`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar evento por ID:', error);
      throw new Error('Erro ao buscar evento por ID.');
    }
  },

  // ➕ Criar novo evento
  async criar(formData) {
    try {
      const { data } = await api.post(baseRoute, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    } catch (error) {
      console.error('❌ Erro ao criar evento:', error);
      throw new Error('Erro ao criar evento.');
    }
  },

  // ✏️ Atualizar evento
  async atualizar(id, formData) {
    try {
      const { data } = await api.put(`${baseRoute}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    } catch (error) {
      console.error('❌ Erro ao atualizar evento:', error);
      throw new Error('Erro ao atualizar evento.');
    }
  },

  // ❌ Excluir evento
  async excluir(id) {
    try {
      const { data } = await api.delete(`${baseRoute}/${id}`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao excluir evento:', error);
      throw new Error('Erro ao excluir evento.');
    }
  },

  // 🧹 Limpar alertas de um evento
  async limparAlertas(eventoId) {
    try {
      const { data } = await api.post(`${baseRoute}/${eventoId}/limpar-alertas`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao limpar alertas:', error);
      throw new Error('Erro ao limpar alertas.');
    }
  },

  // 👧 Listar dependentes diretos do evento
  async listarKids(eventoId) {
    try {
      const { data } = await api.get(`${baseRoute}/${eventoId}/KidsDiretos`);
      return data?.dependentes || [];
    } catch (error) {
      console.error('❌ Erro ao listar kids:', error);
      throw new Error('Erro ao listar kids.');
    }
  },

  // 📊 Buscar resumo do evento
  async buscarResumo(eventoId) {
    try {
      const { data } = await api.get(`${baseRoute}/${eventoId}/Resumo`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar resumo:', error);
      throw new Error('Erro ao buscar resumo.');
    }
  },

  // 🔎 Buscar criança por ID
  async buscarKidById(eventoId, kidId) {
    try {
      const { data } = await api.get(`${baseRoute}/${eventoId}/kids/${kidId}`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar Kid:', error);
      throw new Error('Erro ao buscar Kid.');
    }
  },

  // ➕ Criar novo kid
  async criarKid(eventoId, payload) {
    try {
      const { data } = await api.post(`${baseRoute}/${eventoId}/Kids`, payload);
      return data;
    } catch (error) {
      console.error('❌ Erro ao criar Kid:', error);
      throw new Error('Erro ao criar Kid.');
    }
  },

  // ✏️ Atualizar dados do kid
  async atualizarKid(eventoId, kidId, payload) {
    try {
      const { data } = await api.put(`${baseRoute}/${eventoId}/Kids/${kidId}`, payload);
      return data;
    } catch (error) {
      console.error('❌ Erro ao atualizar Kid:', error);
      throw new Error('Erro ao atualizar Kid.');
    }
  },

  // ❌ Excluir kid
  async excluirKid(eventoId, kidId) {
    try {
      const { data } = await api.delete(`${baseRoute}/${eventoId}/Kids/${kidId}`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao excluir Kid:', error);
      throw new Error('Erro ao excluir Kid.');
    }
  },

  // 🔔 Enviar alerta global
  async enviarAlertaGlobal(payload) {
    try {
      const { data } = await api.post('/api/push/enviar/todos', payload);
      return data;
    } catch (error) {
      console.error('❌ Erro ao enviar push global:', error);
      throw new Error('Erro ao enviar push global.');
    }
  },

  // 🔔 Enviar alerta para usuário específico
  async enviarAlertaUsuario(usuarioId, payload) {
    try {
      const { data } = await api.post(`/api/push/enviar/usuario/${usuarioId}`, payload);
      return data;
    } catch (error) {
      console.error('❌ Erro ao enviar push para usuário:', error);
      throw new Error('Erro ao enviar push para usuário.');
    }
  },

  // 📜 Listar histórico de presença por evento
  async listarHistoricoPorEvento(eventoId) {
    try {
      const { data } = await api.get(`${baseRoute}/${eventoId}/presencas`);
      return data?.itens || [];
    } catch (error) {
      console.error('❌ Erro ao listar histórico por evento:', error);
      return [];
    }
  },

  // 🛑 Finalizar evento
  async finalizarEvento(eventoId) {
    try {
      const { data } = await api.post(`${baseRoute}/${eventoId}/finalizar`);
      return data;
    } catch (error) {
      console.error('❌ Erro ao finalizar evento:', error);
      throw new Error(error?.response?.data?.message || 'Erro ao finalizar evento.');
    }
  }
};

export default EventoApi;
